<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="purple">

            <md-list-item>
              <div class="md-list-item-text">
                <h4 class="title">Your created Offers</h4>
                <p class="category">
                  Here are all your offers
                </p>
              </div>

              <div class="md-layout-item text-right  md-list-action">
                <md-button class="md-raised" @click="addNew()">{{action}}</md-button>
              </div>

            </md-list-item>

          </md-card-header>

          <md-card-content >

              <pulse-loader :loading="loading" :color="color" > </pulse-loader>


              <div v-for="offer in offers" v-show="action==='Add New'">

              <md-card class="md-layout-item md-medium-size-50 md-large-size-50 md-small-size-100">
                <md-card-media-cover md-text-scrim>
                  <md-card-media md-ratio="16:9">
                    <img :src="offer.images[0]" alt="Skyscraper" />
                  </md-card-media>

                  <md-card-area>
                    <md-card-header class="format">
                      <md-button class="md-icon-button md-primary" @click="edit(offer)">
                        <md-icon>edit</md-icon>
                      </md-button>
                      <span class="md-title">{{offer.title}}</span>
                      <span class="md-subhead">{{offer.claims}} of {{offer.stock}} sold</span>
                    </md-card-header>
                  </md-card-area>
                </md-card-media-cover>
              </md-card>

            </div>

            <div v-show="action!=='Add New'" class="md-layout">

              <div class="md-layout-item md-small-size-100 md-size-100">
                <md-field>
                  <label>Offer Title</label>
                  <md-input v-model="offer.title" type="text"> </md-input>
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-100">
                <md-field>
                  <label>Offer Description</label>
                  <md-input v-model="offer.description" type="text"> </md-input>
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-100">
                <p>Gallery</p>

                <div v-show="user!==null" v-for="image in offer.images">
                  <div class="md-layout-item md-small-size-50 md-size-33">
                    <img :src="image" alt="">
                  </div>
                </div>

                <input v-show="this.offer.images.length<3" type="file" id="photo" multiple>

              </div>

              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label>Available Stock / Offers</label>
                  <md-input v-model="offer.stock" type="number"> </md-input>
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label>Original Price</label>
                  <md-input v-model="offer.price" type="number"> </md-input>
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label>Price on offer</label>
                  <md-input v-model="offer.offer" type="number"> </md-input>
                </md-field>
              </div>

              <!--<div class="md-layout-item md-small-size-75 md-size-50">
                <md-field>
                  <label>Comma Separated Tags</label>
                  <md-input v-model="offer.tags" type="text"> </md-input>
                </md-field>
              </div>-->

              <div class="md-layout-item md-small-size-75 md-size-50">
                <md-field>
                  <label>Expiry</label>
                  <md-input v-model="offer.expiry" type="date"> </md-input>
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-100">
                <md-field>
                  <label>Help the buyer know how to collect the offer once purchased</label>
                  <md-input v-model="offer.info" type="text"> </md-input>
                </md-field>
              </div>

            </div>

          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<style>
.format {
  background-color: #00000000 !important;
  border-radius: 0 !important;
  margin: 0 !important;
}
</style>

<script>

import { SimpleTable, OrderedTable } from "@/components";
import firebase from '../Firebase'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
  components: {
    OrderedTable,
    SimpleTable,
      PulseLoader
  },
  data(){
      return{
          loading : true,
          color : "purple",
          action : "Add New",
          user : null,
          offer : {
              title : "",
              description : "",
              stock : 0,
              price : 0,
              offer : 0,
              info : "",
              expiry : "",
              tags : "",
              images : []
              /*"https://cdn-images-1.medium.com/max/1600/0*xMaFF2hSXpf_kIfG.jpg",
              "https://www.downloadnow.top/wp-content/uploads/2018/12/1543756325_maxresdefault.jpg"*/
          },
          images: [],
          offers:[]
      }
  }, created(){

      firebase.auth().onAuthStateChanged(user => {
          this.user = user;

          firebase.firestore().collection("sellers").doc(user.uid).get()
              .then(doc => {
                  if (doc.data()['setup'] < 2)
                      window.location.href = "#/dashboard/outlet";
                  this.user = doc.data()
                  console.log(this.user)
              })
              .catch(reason => {
                  console.log(reason);
                  this.action = "Create"
              });

          firebase.firestore().collection("offers").where("seller", "==", user.uid)
              .onSnapshot( querySnapshot => {
                  this.offers = [];
                  querySnapshot.forEach(document => {
                      this.offers.push(document.data())
                  });
                  this.loading = false;
              })
      });

    },
    methods : {

      addNew(){

          if (this.action === "Add New"){
              this.action = "Create";
              document.getElementById("photo").addEventListener('change', ev => {
                  this.images = ev.target.files;
              })
          }else{

              if (this.offer.title.length>0 && this.offer.description.length>0 && this.offer.info.length>0 && this.offer.stock>0
                  && this.offer.price>0 && this.offer.offer>0 && (this.images.length>0 || this.offer.images.length>0) && this.offer.expiry !== ""){
                  if (this.offer.offer < this.offer.price){
                      this.loading = true;
                      if (this.images.length>0){
                          for (let i = 0; i<this.images.length; i++){
                              let file = this.images[i];
                              firebase.storage().ref("offers").child(file.name).put(file).then(result => {
                                  console.log(result.toString());
                                  result.ref.getDownloadURL().then(url => {
                                      this.offer.images.push(url);
                                      if (this.images.length === this.offer.images.length){
                                          this.setOffer();
                                      }
                                  })
                              }).catch(reason => console.log(reason.message))
                          }

                      }else this.setOffer();

                  }else alert('Offer must be less than price')
              }else alert('Fill all fields')
          }
      },
      setOffer(){

        console.log(new firebase.firestore.GeoPoint(this.user.lat, this.user.lon))

          if (this.action === 'Update'){
              firebase.firestore().collection("offers").doc(this.offer.id).update({
                  "title" : this.offer.title,
                  "description" : this.offer.description,
                  "stock" : parseInt(this.offer.stock + ''),
                  "price" : parseInt(this.offer.price + ''),
                  "offer" : parseInt(this.offer.offer + ''),
                  "info" : this.offer.info,
                  "images" : this.offer.images,
                  "l" : new firebase.firestore.GeoPoint(this.user.lat, this.user.lon),
                  "g" : "",
                  "expiry" :new Date(this.offer.expiry),
                  //"tags"  : this.offer.tags.split(','),
              }).then(result => {
                  this.action = "Add New";
              })
          }else {
              let doc = firebase.firestore().collection("offers").doc();
              doc.set({
                  "id" : doc.id,
                  "title" : this.offer.title,
                  "description" : this.offer.description,
                  "claims" : 0,
                  "stock" : parseInt(this.offer.stock + ''),
                  "price" : parseInt(this.offer.price + ''),
                  "offer" : parseInt(this.offer.offer + ''),
                  "info" : this.offer.info,
                  "images" : this.offer.images,
                  "expiry" :new Date(this.offer.expiry),
                  //"tags"  : this.offer.tags.split(','),
                  "seller" : this.user.uid,
                  "l" : new firebase.firestore.GeoPoint(this.user.lat, this.user.lon),
                  "g" : "",
                  "address" : this.user.address,
                  "building" : this.user.building ? this.user.building : "",
                  "city"  : this.user.city ? this.user.city : "",
                  "street" : this.user.street ? this.user.street : "",
                  "website" : this.user.website ? this.user.website : "",
                  "category" : this.user.category
              }).then(result => {
                  this.action = "Add New";
              })
          }
      },
      edit(offer){
          this.offer = offer;
          this.action = "Update";
      },
      previewFiles(files) {
          this.images = files;
      }

    }
};

</script>
